export const Wrapper = {
  borderWidth: 1,
  borderColor: 'white',
  borderRadius: 10,
  display: 'flex',
  flexDirection: 'row',
};
